/**
 * components/riskTerminal/phone/usePhone.js
 *
 * upstox-076 — below 600 px the Positions screen renders the phone layout; at 600 px and wider,
 * exactly the desktop. 600 is the app's own phone line (index.css: `@media (max-width: 600px)` fixes the
 * top bar and drops the page padding); the layout follows the viewport, not the container.
 */

import { useEffect, useState } from 'react';

export const PHONE_QUERY = '(max-width: 599px)';

export function isPhoneNow() {
  try { return !!(window.matchMedia && window.matchMedia(PHONE_QUERY).matches); } catch (e) { return false; }
}

export default function usePhone() {
  const [phone, setPhone] = useState(isPhoneNow);
  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mq = window.matchMedia(PHONE_QUERY);
    const on = () => setPhone(mq.matches);
    on();
    if (mq.addEventListener) mq.addEventListener('change', on); else mq.addListener(on);
    return () => { if (mq.removeEventListener) mq.removeEventListener('change', on); else mq.removeListener(on); };
  }, []);
  return phone;
}
